import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import Skeleton from '@ynap/skeleton';

const bem = new BEMHelper('DeliveryAndReturnsSkeleton');

const propTypes = {
    className: PropTypes.string,
};

const DeliveryAndReturnsSkeleton = ({ className }) => (
    <ul className={bem()}>
        <li className={className}>
            <Skeleton containerClassName={bem('skeletonComponent', null, 'mode')} className={bem('modeItem')} count={1} />
            <Skeleton containerClassName={bem('skeletonComponent', null, 'price')} className={bem('priceItem')} count={1} />
            <Skeleton containerClassName={bem('skeletonComponent', null, 'description')} className={bem('modeDescription')} count={1} />
        </li>
        <li className={className}>
            <Skeleton containerClassName={bem('skeletonComponent', null, 'mode')} className={bem('modeItem')} count={1} />
            <Skeleton containerClassName={bem('skeletonComponent', null, 'price')} className={bem('priceItem')} count={1} />
            <Skeleton containerClassName={bem('skeletonComponent', null, 'description')} className={bem('modeDescription')} count={1} />
        </li>
    </ul>
);

DeliveryAndReturnsSkeleton.displayName = 'DeliveryAndReturnsSkeleton';

DeliveryAndReturnsSkeleton.propTypes = propTypes;

export default DeliveryAndReturnsSkeleton;
